// features/workstations/property-dossier/history-list.js
// Sidebar of prior dossiers. Mirrors signal-read/history-list.js.

const money = (n) => {
  const v = Number(n);
  if (!Number.isFinite(v) || v === 0) return null;
  return '$' + Math.round(v).toLocaleString();
};
const VERDICT_COLOR = { buy: '#7a9e82', pass: '#c46050', conditional: '#c8a96e' };

export default function HistoryList({ items = [], activeId, onSelect, onNew, onDelete, onClearAll, loading }) {
  return (
    <aside style={{
      width: 260, flexShrink: 0, borderRight: '1px solid var(--border-4)',
      paddingRight: 16, display: 'flex', flexDirection: 'column', gap: 10,
    }}>
      <button
        onClick={onNew}
        style={{
          padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border-2)',
          background: 'var(--surface-3)', color: 'inherit', cursor: 'pointer',
          fontSize: 13, fontWeight: 600, textAlign: 'left',
        }}
      >
        + New analysis
      </button>

      <div style={{ fontSize: 11, color: '#666', textTransform: 'uppercase', letterSpacing: 0.4, marginTop: 4 }}>
        History
      </div>

      {loading && <div style={{ fontSize: 12, color: '#888' }}>Loading…</div>}
      {!loading && items.length === 0 && (
        <div style={{ fontSize: 12, color: '#666' }}>No dossiers yet.</div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, overflowY: 'auto' }}>
        {items.map((it) => {
          const active = it.id === activeId;
          return (
            <div key={it.id} style={{ display: 'flex', alignItems: 'stretch', gap: 4 }}>
              <button
                onClick={() => onSelect(it.id)}
                style={{
                  flex: 1, minWidth: 0, textAlign: 'left', padding: '10px 12px', borderRadius: 8, cursor: 'pointer',
                  background: active ? 'rgba(200,169,110,0.10)' : 'transparent',
                  border: `1px solid ${active ? '#c8a96e' : 'var(--border-4)'}`, color: 'inherit',
                }}
              >
                <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {it.address || it.title || 'Property'}
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 4, fontSize: 11, color: '#888' }}>
                  <span style={{ textTransform: 'uppercase' }}>{it.strategy || '—'}</span>
                  {it.verdict && (
                    <span style={{ color: VERDICT_COLOR[it.verdict] || '#888', fontWeight: 600 }}>{it.verdict}</span>
                  )}
                  {money(it.arv) && <span>ARV {money(it.arv)}</span>}
                </div>
                {it.status && it.status !== 'complete' && (
                  <div style={{ fontSize: 10, color: it.status === 'failed' ? '#c46050' : '#c8a96e', marginTop: 3 }}>{it.status}</div>
                )}
              </button>
              {onDelete && (
                <button
                  onClick={() => onDelete(it.id)}
                  title="Remove this analysis"
                  aria-label="Remove this analysis"
                  className="pd-hist-del"
                  style={{
                    flexShrink: 0, width: 30, borderRadius: 8, cursor: 'pointer',
                    background: 'transparent', border: '1px solid var(--border-4)', color: '#777', fontSize: 16, lineHeight: 1,
                  }}
                >×</button>
              )}
            </div>
          );
        })}
      </div>

      {onClearAll && items.length > 0 && (
        <button
          onClick={onClearAll}
          style={{ marginTop: 8, padding: '6px 4px', background: 'none', border: 'none', color: '#777', cursor: 'pointer', fontSize: 11, textAlign: 'left' }}
        >
          Clear all history
        </button>
      )}

      <style jsx>{`
        .pd-hist-del:hover { color: #c46050 !important; border-color: #c46050 !important; }
      `}</style>
    </aside>
  );
}
